import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface KpiCardProps {
  label: string;
  value: ReactNode;
  delta?: { text: string; isPositive: boolean } | null;
  hint?: string;
  onClick?: () => void;
}

export function KpiCard({ label, value, delta, hint, onClick }: KpiCardProps) {
  const Wrapper = onClick ? 'button' : 'div';
  return (
    <Wrapper
      onClick={onClick}
      className={cn(
        'flex flex-col gap-1 rounded-xl border border-line bg-surface p-4 text-left shadow-card',
        onClick && 'transition-colors hover:border-brand/40',
      )}
    >
      <span className="text-xs font-medium uppercase tracking-wide text-ink-subtle">{label}</span>
      <span className="text-2xl font-bold text-ink">{value}</span>
      {delta ? (
        <span className={cn('text-xs font-medium', delta.isPositive ? 'text-success' : 'text-danger')}>
          {delta.text}
        </span>
      ) : hint ? (
        <span className="text-xs text-ink-subtle">{hint}</span>
      ) : null}
    </Wrapper>
  );
}
